export class EventEmitter<T> {
	private hadlers: ((data: T) => void)[] = [];

	on(handler: (data: T) => void) {
		this.hadlers.push(handler);
	}

	emit(data: T) {
		this.hadlers.forEach(h => h(data));
	}

	off() {
		this.hadlers = [];
	}
}

export class Subject<T> {
	protected subject: T = null;

	protected handlers: ((data: T) => void)[] = [];

	protected fireHandlers(data: T) {
		this.handlers.forEach(h => h(data));
	};

	subscribe(handler: (data: T) => void) {
		this.handlers.push(handler);
	}

	next(data: T) {
		this.subject = data;
		this.fireHandlers(data);
	};

	getValue(): T {
		return this.subject;
	}
}

export class BehaviorSubject<T> extends Subject<T>{
	subscribe(handler: (data: T) => void) {
		super.subscribe(handler);
		if(this.subject){
			super.fireHandlers(this.subject);
		}
	}
}